import { POST } from "./utils";

export const loadMyWorkspaces = async ({
    workspaceCreationName
}: {
    workspaceCreationName?: string;
}) => {
    return await POST("/query/loadMyWorkspaces", { workspaceCreationName });
};

export const getApiKey = async (workspaceId: string) => {
    return await POST("/api/workspace/api-key", { workspaceId });
};

export const setupRapidCreatedWorkspace = async ({ workspaceId }: { workspaceId: string }) => {
    return await POST("/api/workspace/setup", { workspaceId });
};
